import { render, staticRenderFns } from "./UiTooltip.vue?vue&type=template&id=4c8d17ee&scoped=true&"
import script from "./UiTooltip.vue?vue&type=script&lang=ts&"
export * from "./UiTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./UiTooltip.vue?vue&type=style&index=0&id=4c8d17ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8d17ee",
  null
  
)

export default component.exports